var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('activities'),_c('bookings'),_c('coupons'),_c('others')],1)}
var staticRenderFns = []

export { render, staticRenderFns }